export const blockIconsSearchBedroomChild = (
	<span className='material-symbols-outlined'>bedroom_child</span>
);
